// Tipos e helpers de apresentação partilhados pelas páginas de tenants do
// painel de administração da plataforma.

export type TenantPlano = 'FREE' | 'PRO' | 'ENTERPRISE'
export type TenantEstado = 'ACTIVE' | 'SUSPENDED' | 'CANCELLED' | 'PROVISIONING'

/** GET /api/admin/tenants — linha da listagem. */
export interface TenantAdminListItem {
    id: string
    nome: string
    email: string | null
    schemaName: string
    plano: TenantPlano
    estado: TenantEstado
    emailConfirmado: boolean
    criadoEm: string
}

/**
 * GET /api/admin/tenants/{id} — detalhe apresentado no painel. O backend
 * (TenantResponse) devolve também timezone e as flags de estacionamento;
 * são definições operacionais do tenant e não se mostram aqui.
 */
export interface TenantAdminDetail {
    id: string
    nome: string
    email: string | null
    telefone: string | null
    schemaName: string
    plano: TenantPlano
    estado: TenantEstado
    totalCondominios: number
    criadoEm: string
}

export const PLANO_LABEL: Record<TenantPlano, string> = {
    FREE: 'Grátis',
    PRO: 'Pro',
    ENTERPRISE: 'Enterprise',
}

export const ESTADO_TONE: Record<TenantEstado, { label: string; bg: string; color: string }> = {
    ACTIVE: { label: 'Activo', bg: '#F0FDF4', color: '#15803D' },
    SUSPENDED: { label: 'Suspenso', bg: '#FEF3C7', color: '#B45309' },
    CANCELLED: { label: 'Cancelado', bg: '#FEE2E2', color: '#B91C1C' },
    PROVISIONING: { label: 'A provisionar', bg: '#EEF2FF', color: '#3730A3' },
}

export function formatDate(iso: string | null | undefined): string {
    if (!iso) return '—'
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return '—'
    return d.toLocaleDateString('pt-PT', { day: '2-digit', month: 'short', year: 'numeric' })
}
